import { combineReducers } from "redux";

// Front
import Layout from "./layouts/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";

//Calendar
import Calendar from "./calendar/reducer";
//Chat
import chat from "./chat/reducer";

//Project
import Projects from "./projects/reducer";

// Tasks
import Tasks from "./tasks/reducer";
// Tasks
import TasksCrmIt from "./tasksCrmIT/reducer";
//Form advanced
import changeNumber from "./formAdvanced/reducer";

//Crypto
import Crypto from "./crypto/reducer";

//TicketsList
import Tickets from "./tickets/reducer";
//Crm
import Crm from "./crm/reducer";
// CRMit Email Inbox reducer
import EmailInbound from "./CRMitEmailInbox/reducer";
// filters reducer
import Filters from "./filters/reducer";
// jobs data list
import Jobs from "./jobsList/reducer";
// attachment category type
import AttachmentCategoryType from "./attachmentCategoryType/reducer";
// single Job data
import SingleJob from "./singleJob/reducer";
// staff data list
import Staff from "./staff/reducer";
//demo data
import Demo from "./demo/reducer";
// customers data
import Customers from "./customers/reducer";
//Invoice
import Invoice from "./invoice/reducer";
// Invoices
import InvoiceCrmIT from "./invoiceCrmIT/reducer";
// Calendar
import CalendarCrmIT from "./CalendarCrmIT/reducer";
//Products
import ProductCrmIT from "./product/reducer";

//Mailbox

import Mailbox from "./mailbox/reducer";

// Dashboard Analytics
import DashboardAnalytics from "./dashboardAnalytics/reducer";

// Dashboard CRM
import DashboardCRM from "./dashboardCRM/reducer";

// Dashboard Ecommerce
import DashboardEcommerce from "./dashboardEcommerce/reducer";

// Dashboard Cryto
import DashboardCrypto from "./dashboardCrypto/reducer";

// Dashboard Cryto
import DashboardProject from "./dashboardProject/reducer";

// Dashboard NFT
import DashboardNFT from "./dashboardNFT/reducer";

// Pages > Team
import Team from "./team/reducer";

// File Manager
import FileManager from "./fileManager/reducer";

// To do
import Todos from "./todos/reducer";
// Prototype
import Prototype from "./Prototyping/reducer";
// Time Entries
import TimeEntries from "./timeEntries/reducer";

// DropDown
import dropDownReducer from "./dropDown/reducer";
// GlobalTimer
import helperGlobalTimerReducer from "./helperGlobalTimer/reducer";
// Loyalty
import Loyalty from "./loyalty/reducer";
// Business Overview
import BusinessOverview from "./businessOverview/reducer";
// Navigation Menu
import NavigationMenu from "./navigationMenu/reducer";
// Bank
import Bank from "./bank/reducer";
// People
import People from "./people/reducer";
// Site Search
import SiteSearch from "./siteSearch/reducer";
// Advanced Search
import AdvancedSearch from "./advancedSearch/reducer";
// Notification
import Notification from "./notification/reducer";

// ShortcutApps
import ShortcutApps from "./shortcutApps/reducer";
// Products
import Products from "./products/reducer";
// Contract
import Contract from "./contract/reducer";
// Right SideBar
import RightSidebar from "./rightSidebar/reducer";
// Purchase
import Purchase from "./purchase/reducer";
import Supplier from "./supplier/reducer";
// Company To User List
import CompanyToUser from "./companyToUser/reducer";
//Opportunities
import Opportunities from "./opportunities/reducer";
// Quote
import Quote from "./quote/reducer";
// Payment Term
import PaymentTerm from "./paymentTerm/reducer";
// Master Time Frame Interval
import MasterTimeFrameInterval from "./masterTimeFrameInterval/reducer";
// Invoice Items
import InvoiceItems from "./InvoiceItems/reducer";
//ContactPersonLookup
import ContactPersonLookup from "./contactPersonLookup/reducer";
//PaymentMethod
import PaymentMethod from "./paymentMethod/reducer";
// Profit and Loss
import ProfitAndLoss from "./profitAndLoss/reducer";
// Charges
import Charges from "./charges/reducer";
// Leave Request
import LeaveRequest from "./leaveRequest/reducer";
// Dunning
import Dunning from "./dunning/reducer";
//ManageLicense
import ManageLicense from "./manageLicense/reducer";
//Dashboard
import Dashboard from "./dashboard/reducer";
//Recently Viewed
import RecentlyViewed from "./recentlyViewed/reducer";
//Scribe
import Scribe from "./scribe/reducer";
//Liability
import Liability from "./Liability/reducer";
//GeneralSettings
import GeneralSettings from "./generalSettings/reducer";
//VatPeriodExport
import VatPeriodExport from "./vatPeriodExport/reducer";
//YearEndPeriod
import YearEndPeriod from "./YearEndPeriod/reducer";
import Security from "./security/reducer";
import MasterReporting from "./MasterReporting/reducer";
import ReportingDashboard from "./ReportingDashboard/reducer";
import CustomerAcquisitionChannel from "./customerAcquisitionChannel/reducer";
//Appointment
import Appointment from "./appointment/reducer";
//TimeEntriesSummary
import TimeEntriesSummary from "./timeEntriesSummary/reducer";
//FoodPreOrderEventReducer
import FoodPreOrderEventReducer from "./foodPreOederEvent/reducer";
//EventReducer
import EventReducer from "./auth/event/reducer";
import CompaniesHouseGovUK from "./companiesHouseGovUK/reducer";
//OnKeyPressedDownReducer
import OnKeyPressedDownReducer from "./onKeyPressedDown/reducer";
//BackendAdmin
import BackendAdmin from "./backendAdmin/reducer";
//LocalVariables
import LocalVariables from "./localVariables/reducer";
//GPS
import GPS from "./GPS/reducer";
// Vehicle
import Vehicle from "./vehicle/reducer";
// Company Vehicle (fleet)
import CompanyVehicle from "./companyVehicle/reducer";
// PdfTemplate (PDF designer)
import PdfTemplate from "./pdfTemplate/reducer";
// ESign (e-signing envelopes)
import ESign from "./esign/reducer";
// Form Builder (branded forms + submissions)
import Forms from "./forms/reducer";
// Company Storage Location
import CompanyStorageLocation from "./companyStorageLocation/reducer";
// Onboarding
import Onboarding from "./onboarding/reducer";
// Asset
import Asset from "./asset/reducer";
import StaffContact from "./staffContact/reducer";
import Sla from "./sla/reducer";
// Gift Voucher (Task 24310)
import GiftVoucher from "./giftVoucher/reducer";
// Asset Group
import AssetGroup from "./assetGroup/reducer";
// Asset Type
import AssetType from "./assetType/reducer";
// Asset Status
import AssetStatus from "./assetStatus/reducer";
//Checklist
import Checklist from "./checkList/reducer";
//Partners
import Partners from "./partners/reducer";
//ThirdPartyIntegration
import ThirdPartyIntegration from "./thirdPartyIntegration/reducer";
//ProformaInvoice
import ProformaInvoice from "./ProformaInvoice/reducer";
//CompanyRecentActivity
import CompanyRecentActivity from "./Company/reducer";
//FileUploads
import FileUploads from "./FileUploads/reducer";
//Reports
import Reports from "./Reports/reducer";
//feedbackGenReducer
import FeedbackGen from "./feedbackGen/reducer";
//StaffLeave
import StaffLeave from "./staffLeave/reducer";
//SalesOrder
import SalesOrder from "./salesOrder/reducer";
import MasterPaymentProvider from "./masterPaymentProvider/reducer";
//PurchaseOrder
import PurchaseOrder from "./PurchaseOrder/reducer";
//ShiftReport
import ShiftReport from "./ShiftReports/reducer";
//ChatCrmit
import ChatCrmit from "./ChatCrmit/reducer";
//BookATable
import BookATable from "./BookATable/reducer";
//FoodTable
import FoodTable from "./FoodTable/reducer";
//Wifi (R&D)
import Wifi from "./Wifi/reducer";
//Serp (rank tracking)
import Serp from "./Serp/reducer";
//Meeting AI (notetaker)
import MeetingRecording from "./MeetingRecording/reducer";
//CallInbound (Twilio inbound calls)
import CallInbound from "./CallInbound/reducer";
//E-commerce Console (admin) — reads real, writes MOC_ for now
//MessagingServiceReducer
import MessagingServiceReducer from "./MessagingService/reducer";
//PublicPayment
import PublicPayment from "./publicPayment/reducer";
import PublicManualPayment from "./publicManualPayment/reducer";
import Reporting from "./reporting/reducer";
import ReportSaved from "./reportSaved/reducer";
import PurchaseDraft from "./PurchaseDraft/reducer";
import PaymentRequest from "./PaymentRequests/reducer";
import hmrcReducer from "./HMRC/reducer";
import dataImportReducer from "./DataImport/reducer";
import supplierProductReducer from "./SupplierProduct/reducer";
import invoiceDraftReducer from "./InvoiceDraft/reducer";
import bomReducer from "./BOM/reducer";
import ecommerceReducer from "./ecommerce/reducer";
import cronSchedulesReducer from "./cronSchedules/reducer";
//socialMediaManagementReducer
import socialMediaManagementReducer from "./socialMediaManagement/reducer";
import staffPlanner from "./StaffPlanner/reducer";
// leadsReducer
import leadsReducer from "./Leads/reducer";
// automationReducer
import automationReducer from "./Automation/reducer";

//control panel
import controlPanelReducer from "./ControlPanel/reducer";
import brandingReducer from "./branding/reducer";
import SystemModule from "./Module/reducer";
import posSystemReducer from "./posSystem/reducer";
import masterReducer from "./Master/reducer";
import masterConfigItemReducer from "./masterConfigItem/reducer";
import masterThirdPartyPricingReducer from "./masterThirdPartyPricing/reducer";
import masterSimReducer from "./masterSim/reducer";
import masterSystemServerReducer from "./MasterSystemServer/reducer";
import SystemDevice from "./SystemDevice/reducer";
import SystemDeviceHardware from "./SystemDeviceHardware/reducer";
import twilioReducer from "./Twilio/reducer";
import SmsReducer from "./sms/reducer";
import CommunicationReducer from "./communication/reducer";
//DiarySlot
import DiarySlot from "./diarySlot/reducer";
//DispatchBoard
import DispatchBoard from "./dispatchBoard/reducer";
//DiarySlotAssignee
import DiarySlotAssignee from "./diarySlotAssignee/reducer";
//JobTimeEntryReport
import JobTimeEntryReport from "./jobTimeEntryReport/reducer";
//PlacementRevenueReport
import PlacementRevenueReport from "./placementRevenueReport/reducer";
//FoodPreOrderEventReport
import FoodPreOrderEventReport from "./foodPreOrderEventReport/reducer";
//Reviews Centre
import Reviews from "./Reviews/reducer";
//Payroll
import Payroll from "./payroll/reducer";
//System Wallet (Master DB)
import SystemWallet from "./systemWallet/reducer";

const rootReducer = combineReducers({
  // branding
  brandingReducer,
  // control panel
  controlPanelReducer,
  //leads
  leadsReducer,
  //automation
  automationReducer,
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Calendar,
  chat,
  Projects,
  Tasks,
  TasksCrmIt,
  changeNumber,
  Crypto,
  Tickets,
  Crm,
  EmailInbound,
  Customers,
  Filters,
  Jobs,
  AttachmentCategoryType,
  SingleJob,
  Staff,
  Demo,
  Invoice,
  InvoiceCrmIT,
  CalendarCrmIT,
  ProductCrmIT,
  Mailbox,
  DashboardAnalytics,
  DashboardCRM,
  DashboardEcommerce,
  DashboardCrypto,
  DashboardProject,
  DashboardNFT,
  Team,
  FileManager,
  Todos,
  Prototype,
  TimeEntries,
  dropDownReducer,
  helperGlobalTimerReducer,
  Loyalty,
  BusinessOverview,
  NavigationMenu,
  Bank,
  People,
  SiteSearch,
  AdvancedSearch,
  Notification,
  ShortcutApps,
  Products,
  Contract,
  RightSidebar,
  Purchase,
  Supplier,
  CompanyToUser,
  Opportunities,
  Quote,
  PaymentTerm,
  MasterTimeFrameInterval,
  InvoiceItems,
  ContactPersonLookup,
  PaymentMethod,
  ProfitAndLoss,
  Charges,
  LeaveRequest,
  Dunning,
  ManageLicense,
  Dashboard,
  RecentlyViewed,
  Scribe,
  Liability,
  GeneralSettings,
  VatPeriodExport,
  YearEndPeriod,
  Security,
  MasterReporting,
  ReportingDashboard,
  CustomerAcquisitionChannel,
  Appointment,
  TimeEntriesSummary,
  FoodPreOrderEventReducer,
  EventReducer,
  CompaniesHouseGovUK,
  OnKeyPressedDownReducer,
  BackendAdmin,
  LocalVariables,
  GPS,
  Vehicle,
  CompanyVehicle,
  PdfTemplate,
  ESign,
  Forms,
  CompanyStorageLocation,
  Onboarding,
  Asset,
  StaffContact,
  Sla,
  GiftVoucher,
  AssetGroup,
  AssetType,
  AssetStatus,
  Checklist,
  Partners,
  ThirdPartyIntegration,
  ProformaInvoice,
  CompanyRecentActivity,
  FileUploads,
  Reports,
  StaffLeave,
  FeedbackGen,
  SalesOrder,
  MasterPaymentProvider,
  PurchaseOrder,
  ShiftReport,
  ChatCrmit,
  BookATable,
  FoodTable,
  Wifi,
  Serp,
  MeetingRecording,
  CallInbound,
  MessagingServiceReducer,
  PublicPayment,
  PublicManualPayment,
  Reporting,
  ReportSaved,
  PurchaseDraft,
  PaymentRequest,
  hmrcReducer,
  dataImportReducer,
  supplierProductReducer,
  invoiceDraftReducer,
  bomReducer,
  ecommerceReducer,
  cronSchedulesReducer,
  socialMediaManagementReducer,
  staffPlanner,
  SystemModule,
  posSystemReducer,
  masterReducer,
  masterConfigItemReducer,
  masterThirdPartyPricingReducer,
  masterSimReducer,
  masterSystemServerReducer,
  SystemDevice,
  SystemDeviceHardware,
  twilioReducer,
  SmsReducer,
  CommunicationReducer,
  DiarySlot,
  DispatchBoard,
  DiarySlotAssignee,
  JobTimeEntryReport,
  PlacementRevenueReport,
  FoodPreOrderEventReport,
  Reviews,
  Payroll,
  SystemWallet,
});

export default rootReducer;
